import type { IMaskFunction } from 'interfaces/IMask';
import { cleanCpfAndCnpj, formatCpfAndCnpj } from 'v2/helpers/cpfCnpj';

const document: IMaskFunction = {
  apply: formatCpfAndCnpj,
  clean: cleanCpfAndCnpj
};

export default document;
